import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const Cart: React.FC = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const mode = queryParams.get('mode') || 'open';
    return <Navigate to={`/?cart=${mode}`} replace />;
};

export default Cart;